export const isFileImage = function (mime: any) {
  return mime.includes('image');
};
